import { Component, OnInit, HostBinding, Input, HostListener, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'unh-animated-like-button',
  templateUrl: './animated-like-button.component.html',
  styleUrls: ['./animated-like-button.component.scss']
})
export class AnimatedLikeButtonComponent {
  animate = false;

  @Input() animated = false;
  @Input() resetOnEnd = true;

  @Output() animationCompleted = new EventEmitter();

  @HostBinding('class.animate')
  get _animate() { return !this.animated && this.animate; }

  @HostBinding('class.animated')
  get _animated() { return this.animated; }

  @HostListener('click')
  onClick() {
    if (!this.animated) {
      this.animate = true;

      setTimeout(() => {
        this.animationCompleted.emit(true);

        if (this.resetOnEnd) {
          this.animate = false;
        }
      }, 350);
    }
  }
}
